import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import { condition } from './condition.js'
import { auth } from './auth.js'

const store = createStore({
    modules: {
        distributor: {
            namespaced: true,
            modules: {
                auth,
                condition,
            }
        }
    },
    plugins: [
        createPersistedState({
            key: 'vuetest',
            /*
            paths: [
                'auth.isLoggedIn',
                'master.dataSelected'
            ],
            */
            //storage: window.sessionStorage
        })
    ]
})

export default store
